/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'
import useUtils from './useUtils'
import {useDispatch, useSelector} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import Pagination from '../../modules/pagination/Pagination'
import TableSkeleton from '../../modules/skeleton/TableSkelton'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'
import {saveAs} from 'file-saver'
import {unparse} from 'papaparse'
import Papa from 'papaparse'
import {showAlert} from '../../redux/reducers/alertSlice'
import CSVModal from '../../modules/modal/CSVModal'
import {useHelper} from '../../../_metronic/helpers/useHelper'
import UploadAlert from '../../modules/alert/UploadingAlert'
import {useBlocker} from '../../../_metronic/helpers/useBloker'
const UnitList = ({className}) => {
  const {
    addCSV,
    fetchUnits,
    fetchCohorts,
    fetchLanguages,
    fetchAllUnits,
    fetchSeasons,
    submitReport,
  } = useUtils()
  const {handleEdit, deleteUnit} = useUtils()
  const [units, setUnits] = useState(null)
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(1)
  const previousSearchTerm = useRef('')
  const fileInputRef = useRef(null)

  const {createSmartChunks} = useHelper()
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const pendingTxRef = useRef(null)

  const seasonsOptions = useSelector((state) => state?.season.records)
  const [isOpen, setIsOpen] = useState(false)
  const [csvData, setcsvData] = useState(null)
  const [isUpload, setIsUpload] = useState(false)

  const [downloadLoading, setDownloadLoading] = useState(false)
  const [uploadLoading, setUploadLoading] = useState(false)

  const [searchTerm, setSearchTerm] = useState('')
  const cohortOptions = useSelector((state) => state?.cohort?.records)
  const statusOptions = ['drafts', 'published']

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedSeason, setSelectedSeason] = useState(null)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Unit'))

  const [selectedStatus, setSelectedStatus] = useState(null)
  const [selectedCohort, setSelectedCohort] = useState(null)

  const count = units?.count

    useBlocker((tx) => {
      pendingTxRef.current = tx
      setShowConfirmModal(true)
    }, uploadLoading)
  
    const handleConfirmLeave = () => {
      setShowConfirmModal(false)
      window.location.href = document.referrer || '/' 
    }
    
    const handleCancelLeave = () => {
      pendingTxRef.current = null
      setShowConfirmModal(false)
    }

  const getUnits = async () => {
    try {
      if (searchTerm === previousSearchTerm.current) {
        setLoading(true)
      }
      const offset = (page - 1) * limit
      const result = await fetchUnits(
        searchTerm,
        selectedStatus,
        selectedCohort,
        selectedSeason,
        limit,
        offset
      )
      setTotalPages(Math.ceil(result?.count / limit))
      setUnits(result)
      previousSearchTerm.current = searchTerm
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(
      () => {
        getUnits()
      },
      searchTerm ? 500 : 0
    )
    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, selectedStatus, limit, selectedCohort, selectedSeason, page])

  useEffect(() => {
    fetchCohorts()
    fetchLanguages()
    fetchSeasons()
  }, [])

  const handleDelete = (id) => {
    setSelectedId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedId) return
    try {
      setLoading(true)
      const result = await deleteUnit(selectedId, limit, (page - 1) * limit)
      setUnits(result)
    } catch (error) {
      console.error('Error deleting course:', error)
    } finally {
      setLoading(false)
      setModalVisible(false)
      setSelectedId(null)
    }
  }

  const handleStatusChange = (status) => {
    setSelectedStatus(status)
  }

  const handleCohortChange = (cohortId) => {
    setSelectedCohort(cohortId)
  }

  const handleSeasonChange = (seasonId) => {
    setSelectedSeason(seasonId)
  }

  const onPreview = async (id) => {
    const result = await handleEdit(id)
    let values = {
      id: result.id,
      code: result?.code,
      unitName: result?.name,
      imgUrl: result?.imageUrl,
      bannerImage: null,
      cohort: result?.cohort?.title,
      shortDescription: result?.description,
      language: result?.language?.name,
      videos: result?.unitVideo?.map((uv) => uv.video),
      tags: result?.tag?.map((tags) => tags.name),
      cohortId: result?.cohortId,
      languageId: result?.languageId,
      status: result?.status,
    }
    navigate('/unitlist/preview-unit', {state: {values}})
  }

  const handleDownload = async () => {
    try {
      setDownloadLoading(true)
      const data = await fetchAllUnits(searchTerm, selectedStatus, selectedCohort, selectedSeason)

      const csv = unparse(data, {header: true})

      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      saveAs(blob, 'units.csv')
    } catch (error) {
      console.error('Error downloading units:', error)
    } finally {
      setDownloadLoading(false)
    }
  }

  const uploadFile = async (data) => {
    let successRecords = 0
    const failedRecords = []
    try {
     
      const chunks = createSmartChunks(data)
      const uploadPromises = chunks.map((chunk) => addCSV(chunk))
      const response = await Promise.all(uploadPromises)

        response.forEach((response) => {
          if (response.success) {
            successRecords += response.success
          }
          if (response.failed?.length > 0) {
            failedRecords.push(...response.failed) // Aggregate failed records
          }
        })

        const successMessage = successRecords ? `${successRecords} units uploaded successfully` : ''
        const failedMessage = failedRecords.length
          ? `${failedRecords.length} units failed to upload`
          : ''
        const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
        dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))

      const finalSummary = {
        recordType: 'Units',
        totalRecords: data.length,
        successRecords: successRecords,
        failedRecords: failedRecords,
      }

      const res = await submitReport(finalSummary)
      if (res) {
        dispatch(
          showAlert({message: 'Report Submitted Successfully', variant: 'info', timeout: 5000})
        )
      } else {
        console.log('Error')
      }
    } catch (error) {
      console.error('Error uploading units:', error)
    } finally {
      setUploadLoading(false)
      getUnits()
    }
  }

  const handleFileChange = (event) => {
    setUploadLoading(true)
    const file = event.target.files[0]
    if (file) {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            setIsOpen(true)
            setcsvData(result?.data)
            event.target.value = null
          },
          error: (error) => {
            console.error('Error parsing CSV:', error)
          },
        })
      } else {
        dispatch(showAlert({message: 'Please select a valid CSV file.', variant: 'danger'}))
      }
    }
  }

  useEffect(() => {
    if (csvData) {
      const transformedData = csvData?.map((obj, index) => ({
        id: obj?.id,
        name: obj?.name,
        code: obj?.code,
        description: obj?.description,

        languageId: obj?.language,
        cohortId: obj?.cohort,
        seasonId: obj?.season,

        videoId: obj.videoId,
        videoTitle: obj.videoTitle,
        videoLink: obj.videoLink,
        videoDescription: obj.videoDescription,
        
        tags: obj.tags ? obj.tags.split(',').map((tag) => tag.trim()) : [],
      }))
      const dataToUpload = transformedData.slice(0, -1)
      uploadFile(dataToUpload)
      setcsvData(null)
    }
  }, [isUpload])

  const onEdit = async (id) => {
    const result = await handleEdit(id)
    navigate('/unitlist/editunit', {state: {result}})
  }

  if (loading) return <TableSkeleton />

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start'>
          {/* <span className='card-label fw-bold fs-3 mb-1'>Units List</span> */}
          <span className=' mt-1 text-muted fs-7 '>{count} Items</span>
        </h3>
        {/* begin::Search */}
        <div className='mt-5 d-flex align-items-center justify-content-between w-100 flex-wrap'>
          <div className='d-flex align-items-center flex-wrap'>
            <div className='d-flex align-items-center flex-wrap gap-3'>
              <div className='d-flex align-items-center my-1'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-3 position-absolute ms-6'
                />
                <input
                 disabled={uploadLoading}
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control fs-7 form-control-solid w-250px h-40px ps-14'
                  placeholder='Search Units'
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                    setPage(1)
                  }}
                />
                {/* end::Search */}
              </div>

              <div>
                <select
                 disabled={uploadLoading}
                  value={selectedStatus || ''}
                  className='form-select form-select-solid fs-7 text-muted h-40px w-150px select2-hidden-accessible'
                  onChange={(e) => handleStatusChange(e.target.value)}
                >
                  <option value={null}>Status</option>
                  {statusOptions.map((status, index) => (
                    <option key={index} value={status} data-select2-id='select2-data-12-vz6w'>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <select
                 disabled={uploadLoading}
                  value={selectedCohort || ''}
                  className='form-select form-select-solid fs-7 text-muted h-40px w-150px select2-hidden-accessible'
                  onChange={(e) => handleCohortChange(e.target.value)}
                >
                  <option>Cohort</option>

                  {cohortOptions.map((cohort, index) => (
                    <option key={index} value={cohort.id}>
                      {cohort.title}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <select
                 disabled={uploadLoading}
                  value={selectedSeason || ''}
                  className='form-select fs-7 form-select-solid h-40px text-muted  w-150px select2-hidden-accessible'
                  onChange={(e) => handleSeasonChange(e.target.value)}
                >
                  <option>Season</option>
                  {seasonsOptions.map((season, index) => (
                    <option key={index} value={season.id}>
                      {season.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className='card-toolbar'>
            <div>
              <span
                onClick={() => fileInputRef.current.click()}
                className='btn btn-sm btn-light-primary me-2'
              >
                {uploadLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <>
                    <KTSVG path='/media/icons/duotune/files/fil010.svg' className='svg-icon-2' />
                    Upload CSV
                  </>
                )}
              </span>
              <input
                type='file'
                ref={fileInputRef}
                style={{display: 'none'}}
                accept='.csv'
                onChange={handleFileChange}
              />
            </div>

            <span onClick={() => handleDownload()}  className={`btn btn-sm  btn-light-primary me-2 ${uploadLoading ? 'disabled' : ''}`}>
              {downloadLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                <>
                  <KTSVG path='/media/icons/duotune/files/fil003.svg' className='svg-icon-2 me-1' />
                  Download CSV
                </>
              )}
            </span>

            <span
              onClick={() => navigate('/unitlist/addunit')}
              className={`btn btn-sm  btn-light-primary  ${uploadLoading ? 'disabled' : ''}`}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
              Add Unit
            </span>
          </div>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      {count === 0 && (
        <div className='mt-20 mb-20 w-sm-100 w-md-75 mx-auto p-5 py-20'>
          <div className='card-body text-center'>
            <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
              <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
            </span>
            <h4 className='mb-1'>No Records Found</h4>
            <span>Add more Units or change the filters</span>
          </div>
        </div>
      )}

      {count > 0 && (
        <div className='card-body py-10'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='min-w-50px'>CODE</th>
                  <th className='min-w-50px'>ID</th>
                  <th className='min-w-80px'>TITLE</th>
                  <th className='min-w-80px'>COHORT</th>
                  <th className='min-w-80px'>STATUS</th>
                  <th className='min-w-150px text-end'>ACTIONS</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {units?.records &&
                  units?.records?.map((value, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <span className='text-dark  fw-bold  fs-6'>
                            {value.code}
                          </span>
                        </td>
                        <td className='text-nowrap'>
                          <span className='text-dark  fw-bold  fs-6'>
                            {value.id}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark text-nowrap  fw-bold  d-block mb-1 fs-6'>
                            {value.name}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark  fw-bold  d-block mb-1 fs-6'>
                            {value.cohort?.title}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              value.status === 'published' ? 'badge-success' : 'badge-danger'
                            }`}
                          >
                            {value.status}
                          </span>
                        </td>

                        <td className='d-flex  justify-content-end'>
                          <span
                            onClick={() => onPreview(value.id)}
                            className={`btn btn-icon btn-bg-light  ${uploadLoading ? 'disabled' : ''} btn-active-color-primary btn-sm me-1`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen019.svg'
                              className='svg-icon-3 svg-icon-primary'
                            />
                          </span>
                          <span
                            onClick={() => onEdit(value.id)}
                            className={`btn btn-icon btn-bg-light  ${uploadLoading ? 'disabled' : ''} btn-active-color-primary btn-sm me-1`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/art/art005.svg'
                              className='svg-icon-3 svg-icon-primary'
                            />
                          </span>
                          <span
                            onClick={() => handleDelete(value.id)}
                            className={`btn btn-icon btn-bg-light  ${uploadLoading ? 'disabled' : ''} btn-active-color-primary btn-sm me-1`}
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen027.svg'
                              className='svg-icon-3 text-danger'
                            />
                          </span>
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
      )}

      <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
        <div className='d-flex align-items-center gap-3'>
          <span className='fs-6 text-muted'>Show</span>
          <div>
            <select
              defaultValue={limit}
              disabled={uploadLoading}
              className='form-select form-select-solid text-muted select2-hidden-accessible'
              onChange={(e) => {
                setPage(1)
                setLimit(e.target.value)
              }}
            >
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </select>
          </div>
        </div>
        <DeleteConfirmation
          isVisible={modalVisible}
          message='Are you sure you want to delete this Unit?'
          onConfirm={confirmDelete}
          onCancel={() => setModalVisible(false)}
        />
        {isOpen && (
          <CSVModal
            show={isOpen}
            upload={() => setIsUpload((prev) => !prev)}
            handleClose={() => {
              setIsOpen(false)
            }}
            handleCancel={() =>{ 
              setUploadLoading(false)
              setIsOpen(false)
            }}
            csvData={csvData}
          />
        )}
         <UploadAlert
            isVisible={showConfirmModal}
            message='Data is being uploaded. Are you sure you want to leave?'
            onConfirm={handleConfirmLeave}
            onCancel={handleCancelLeave}
          />
        <Pagination isDisable={uploadLoading}  currentPage={page} totalPages={totalPages} onPageChange={setPage} />
      </div>
      {/* begin::Body */}
    </div>
  )
}

export default UnitList
